import { PRICETYPES } from "../../../utilities/constants";
import { defineHTMLForAddToFavoritesButton } from "./quickViewFavoritesInteractions";

/**
 * Defines the HTML for Pricing area
 * @param {Object} product
 */
const defineHTMLForPricingArea = (product, resources, checkoutPage, addToFavoritesButtonHTML) => {
    const {price, pricePerUnit} = product;
    const isPriceRange = price && price.isPriceRange;
    const salePrice = price && price.sales ? price.sales : null;
    const salePriceValue = salePrice ? salePrice.formatted : "";
    const primaryPrice = pricePerUnit.primaryPrice;
    const primaryUnit = primaryPrice && primaryPrice.unit ? "/" + primaryPrice.unit : "";
    const secondaryPrice = pricePerUnit && pricePerUnit.secondaryPrice ? pricePerUnit.secondaryPrice : null;
    const secondaryUnit = secondaryPrice && secondaryPrice.unit ? "/" + secondaryPrice.unit : "";
    const secondaryPriceValue = secondaryPrice && secondaryPrice.price ? secondaryPrice.price : "";

    let priceRangeLabel = isPriceRange ? `<span class="price-starting-label">${resources.priceRangeLabel}</span>` : "";
    let priceHTML =
        `<div class="ct-pdp--prices mr-2">
            <div class="prices-wrapper">
                <span class="d-block sales pwc-tile--price-primary ">
                    ${priceRangeLabel}
                    <span class="value d-inline-flex" content="${salePrice.value ? salePriceValue : secondaryPriceValue}">
                        <span class="ct-price-formatted align-content-center">${salePrice.value ? salePriceValue : secondaryPriceValue}</span><span class="pwc-m-unit">${primaryUnit}</span>
                        ${!checkoutPage ? `<div class="d-flex ml-4">
                            ${defineHTMLForAddToFavoritesButton(addToFavoritesButtonHTML)}
                        </div>` : ""}
                    </span>
                </span>
                ${salePrice.value != 0 ? defineHTMLForStrikeoutPricingArea(product, resources) : ""}
            </div>
            <div class="pwc-tile--price-secondary">
                <span class="ct-price-value">
                    ${secondaryPriceValue}
                </span>
                <span class="pwc-m-unit">
                    ${secondaryUnit}
                </span>
            </div>
            ${defineHTMLForDiscountMessage(product)}
        </div>`;

    return priceHTML;
};

/**
 * Defines the HTML for Strikeout Pricing area
 * @param {Object} product
 * @param {Object} resources
 */
const defineHTMLForStrikeoutPricingArea = (product, resources) => {
    const {price, pricePerUnit, badgeInfo, separatorResource} = product;
    const { list } = price || {};
    const { decimalPrice, formatted} = list || {};
    let strikeoutPriceHTML = "";

    if (list == null || formatted == null) { return strikeoutPriceHTML; }
    if (badgeInfo && (!badgeInfo.promo || (badgeInfo.promo.type != PRICETYPES.LOYALTY && badgeInfo.promo.type != PRICETYPES.PVPR))) {
        let hasPrimaryPriceAndUnit = pricePerUnit && pricePerUnit.primaryPrice && pricePerUnit.primaryPrice.unit;
        let dashedPriceHTML = hasPrimaryPriceAndUnit ?
            `<span class="pwc-tile--price-dashed">
                ${separatorResource}
            </span>` : "";

        strikeoutPriceHTML = `
            <span class="strike-through list pwc-tile--price-dashed">
                <span class="value pwc-tile--price-value" content="${decimalPrice}">
                    <span class="sr-only">
                        ${resources.priceFromLabel}
                    </span>
                    ${formatted}
                    ${dashedPriceHTML}
                    <span class="sr-only">
                        ${resources.priceToLabel}
                    </span>
                </span>
            </span>
        `;
    }

    return strikeoutPriceHTML;
};

/**
 * Defines the HTML for Discount message
 * @param {Object} product
 */
const defineHTMLForDiscountMessage = product => {
    const { price, badgeInfo } = product;
    let discountMsgHTML = "";
    let promoType = "";
    let badgeClass = "pwc-discount-amount";

    if (badgeInfo && badgeInfo.promo && badgeInfo.promo.msg) {
        promoType = "promo";
        if (badgeInfo.promo.type && badgeInfo.promo.type == PRICETYPES.PVPR) {
            badgeClass = badgeClass + " pwc-discount-amount-pvpr";
        }
    } else if (badgeInfo && badgeInfo.general && badgeInfo.general.msg) {
        promoType = "general";
    }

    if (promoType != "") {
        discountMsgHTML = `<p class="${badgeClass}">${badgeInfo[promoType].msg}</p>`;
    } else if (price && price.badgeInfo) {
        discountMsgHTML = `<p class="${badgeClass}">${price.badgeInfo}</p>`;
    }

    return discountMsgHTML;
};

export { defineHTMLForPricingArea };
